export default __webpack_public_path__ + "static/assignee-dont-dark-4634c7d699f7014415d1c31f2d5da808.png";